import React from 'react';

type NameDataType = {
  firstName: string;
  lastName: string;
}

type AppProps = {
  disabled: boolean;
  handleSetFirstName: (e: any) => void;
  handleSetLastName: (e: any) => void;
  firstNameError: string;
  nameData: NameDataType;
}


const ChangeUserName = ({
  disabled,
  firstNameError,
  handleSetFirstName,
  handleSetLastName,
  nameData
}: AppProps) => {
  return (
    <>
      <div className="form-group">
        <div className="">
          <label htmlFor="formData"
          >Enter First Name</label>
          <input
            type="text"
            className={`form-control w-25 ${ !!firstNameError ? "error-border" : null }`}
            disabled={disabled}
            value={nameData.firstName}
            autoComplete="off"
            onChange={(e: any) => handleSetFirstName(e)}
          />
        </div>
        {!!firstNameError && <small className="text-danger">{firstNameError}</small>}
      </div>
      <div className="form-group">
        <div className="">
          <label htmlFor="formData"
          >Enter Last Name</label>
          <input
            type="text"
            className="form-control w-25"
            disabled={disabled}
            value={nameData.lastName}
            autoComplete="off"
            onChange={(e: any) => handleSetLastName(e)}
          />
        </div>
      </div>
    </>
  )
}

export default ChangeUserName;